import ReadMoreBlock from './ReadMoreBlock';

export default ReadMoreBlock;
